export const RegexField = {
  email:
    /^(([^<>()[\]\\.,;:\s@\\"]+(\.[^<>()[\]\\.,;:\s@\\"]+)*)|(\\".+\\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  password: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@#$!%*?&])[A-Za-z\d@#$!%*?&]{8,}$/,
  numbers: /^[0-9]*$/,
  percent: /^(?:\d{1,2}(?:\.\d{1,4})?|100(?:\.0?0)?)$/,
  phone: /^(84|0[3|5|7|8|9])+([0-9]{8})\b$/,
}
